var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _path3, _rect6, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 24,
    height: 28,
    rx: 2,
    fill: "#2FB776"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 21H32V26C32 27.1046 31.1046 28 30 28H10C8.89543 28 8 27.1046 8 26V21Z",
    fill: "url(#paint0_linear_3729_393785)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 12,
    height: 7,
    fill: "#229C5B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 7,
    width: 12,
    height: 7,
    fill: "#27AE68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C8 0.89543 8.89543 0 10 0H20V7H8V2Z",
    fill: "#1D854F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 12,
    height: 7,
    fill: "#197B43"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 12,
    height: 7,
    fill: "#1B5B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C8 8.34315 9.34315 7 11 7H17C18.6569 7 20 8.34315 20 10V22C20 23.6569 18.6569 25 17 25H8V10Z",
    fill: "black",
    fillOpacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 18,
    height: 18,
    rx: 2,
    fill: "url(#paint1_linear_3729_393785)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19L10.1821 13.9L12.8763 9H10.677L9.01375 12.1286L7.37801 9H5.10997L7.81787 13.9L5 19H7.19931L8.97251 15.6857L10.732 19H13Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3729_393785",
    x1: 8,
    y1: 24.5,
    x2: 32,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#163C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3729_393785",
    x1: 0,
    y1: 14,
    x2: 18,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176F3D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "0b24017b0bf516025ea31d3b79b42db5.svg";
export { ForwardRef as ReactComponent };